import React, { useEffect, useMemo, useState } from "react";

import withObserver from "../../moduleable/modules/hoc/withObserver.js"
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from "../style.module.scss"
import ProductStarScore from "../module/product-star-score/index.jsx";
import { useSelector, useDispatch } from 'react-redux'

import { fetchTranslateReview } from "../../../../api/index"
import { action_fetch_product_detail_translateData, action_fetch_product_review } from "../../../../store/actions/pages/product"

import { BlackMask } from "../../../components/mask";
import BottomToTop from '../../../components/transitions/bottom-to-top'
import RightToLeft from "../../../components/transitions/right-to-left.jsx";

import { withList } from "../hoc/withList"
import { FormattedMessage, useIntl } from 'react-intl'
import { Iconfont } from "../../../components/icon/iconfont.jsx";
import { Swiper, SwiperSlide } from 'swiper/react';
import { IMAGE_GEEKO_LTD } from "../../../../constants/index.js";
import ReactDOM from "react-dom";
import SwiperCore, {
    Pagination,
} from 'swiper';

SwiperCore.use([Pagination]);

const ProductReviewEvaluate = props => {
    const { sizingRecommendation, isDetail } = props;
    const intl = useIntl()

    let large = sizingRecommendation.tooLarge;
    let fit = sizingRecommendation.goodFit;
    let small = sizingRecommendation.tooSmall;
    let total = (large + fit + small);
    let percentSmall = small / total;
    let percentFit = fit / total;
    let percentLarge = large / total;

    const reviewData = [
        {
            id: 1,
            title: intl.formatMessage({ id: 'too_small' }),
            percent: Math.round(percentSmall * 100).toFixed(1)
        },
        {
            id: 2,
            title: intl.formatMessage({ id: 'ture_to_size' }),
            percent: Math.round(percentFit * 100).toFixed(1)
        },
        {
            id: 3,
            title: intl.formatMessage({ id: 'to_large' }),
            percent: Math.round(percentLarge * 100).toFixed(1)
        }
    ];

    return (
        <React.Fragment>
            {
                total > 0 && <div className={classes.ProductReviewEvaluate} style={{ padding: `${!isDetail ? 0 : undefined}` }}>
                    <div className={classes.CommentSummaryContainer} style={{ backgroundColor: `${!isDetail ? "transparent" : undefined}`, padding: `${!isDetail ? 0 : undefined}` }}>
                        {
                            reviewData?.map((comment, index) => <div key={comment.id + index} className={classes.CommentSummaryItem}>
                                <div>{comment.title}</div>
                                <div className={classes.Progress}>
                                    <span>
                                        <span style={{ width: `${comment.percent}%` }}></span>
                                    </span>
                                </div>
                                <div>{comment.percent}%</div>
                            </div>
                            )
                        }
                    </div>
                </div>

            }
        </React.Fragment>
    )
}

const ProductMoreReviewItem = props => {
    const { translateData, productId, total, sizingRecommendation, avgScore, onClose } = props;
    const pageProduct = useSelector((state) => state.pageProduct);
    const dispatch = useDispatch();

    const sizingRecommendationTotal = (sizingRecommendation?.tooLarge) + (sizingRecommendation?.goodFit) + (sizingRecommendation?.tooSmall);

    useEffect(async () => {
        await dispatch(action_fetch_product_review(productId, pageProduct?.reviewSkip));
    }, []);

    const onScroll = async () => {
        await dispatch(action_fetch_product_review(productId, pageProduct?.reviewSkip));
    }


    return <React.Fragment>
        <div className={classes.ProductMoreReviewHd}>
            <span className={classes.Font}><FormattedMessage id="reviews" defaultMessage="Reviews" />({total})</span>
            <span className={`iconfont ${classes.Icon}`} onClick={onClose}>&#xe693;</span>
        </div>

        {
            pageProduct?.reviewList && <ProductReviewList comments={pageProduct?.reviewList} request={onScroll} translateData={translateData} loading={pageProduct?.reviewLoading} finished={pageProduct?.reviewFinished}>
                {
                    sizingRecommendationTotal > 0 && <div className={classes.ModalReviewEvaluate}>
                        <div>
                            <p>{avgScore.toFixed(1)}</p>
                            <div className={classes.ReviewCount}>
                                <ProductStarScore starScore={avgScore} />
                            </div>
                        </div>

                        <ProductReviewEvaluate isDetail={false} sizingRecommendation={sizingRecommendation} />
                    </div>
                }
            </ProductReviewList>
        }
    </React.Fragment>
}

const ProductMoreReviewModal = props => {
    const { moreReviewShow } = props;

    return (
        <React.Fragment>
            <RightToLeft in={moreReviewShow} className={classes.ProductMoreReview}>
                <div>
                    <ProductMoreReviewItem {...props} />
                </div>
            </RightToLeft>
        </React.Fragment>
    )
}

const ProductSelectTranslateModal = props => {
    const { translateData, selectedLanguage, showModal, onClose, changeLanguage } = props;

    return (
        <React.Fragment>
            <BottomToTop in={showModal} className={classes.TranslateModal}>
                <div>
                    <div className={classes.TranslateContainerModal}>
                        <div className={classes.TranslateHd}><FormattedMessage id="translare_to" defaultMessage="Translate To" /></div>

                        <div className={classes.TraslateBd}>
                            <ul>
                                {
                                    translateData?.map((item, index) => <li className={`${selectedLanguage === item.value ? classes.Active : ""}`} onClick={() => changeLanguage(item.value)} key={index}>{item.label}</li>)
                                }
                            </ul>
                        </div>

                        <div className={classes.TranslateFd} onClick={onClose}><FormattedMessage id="cancel" defaultMessage="Cancel" /></div>
                    </div>

                </div>
            </BottomToTop>

            {
                showModal && <BlackMask onClick={onClose} />
            }

        </React.Fragment>
    )
}

const ReviewImageMagnifyItem = props => {
    const { images, onClose } = props;

    const pagination = {
        clickable: true,
        bulletActiveClass: classes.Active
    };

    return <>
        {
            images?.length > 0 && <div className={classes.ReviewImageMagnify} onClick={onClose}>
                <div className={classes.ReviewImageMagnifyitem}>
                    <Swiper
                        slidesPerView='auto'
                        onSlideChange={() => console.log()}
                        onSwiper={(swiper) => console.log()}
                        pagination={pagination}
                        loop={true}
                    >
                        {
                            images?.map((item, index) => <SwiperSlide key={index}>
                                <img src={`${IMAGE_GEEKO_LTD}/comment/medium/${item}`} alt="Review" />
                            </SwiperSlide>)
                        }
                    </Swiper>
                </div>
            </div>
        }
    </>
}

const ReviewImageMagnify = props => {
    return ReactDOM.createPortal(
        <ReviewImageMagnifyItem {...props} />,
        document.getElementById('root')
    )
}

const ProductReviewItem = props => {
    const { comment, translateData, index } = props;
    const [content, setContent] = useState(null);
    const global = useSelector(state=>state.global);
    const [defaultLanguage, setDefaultLanguage] = useState("en");
    const [showModal, setShowModal] = useState(false);
    const [images, setImages] = useState(null);
    const intl = useIntl();

    useEffect(() =>{
        if(translateData?.length > 0 && global?.language){
            let language = currentLanguage(translateData, global?.language);
            setDefaultLanguage(language);
        }
    },[translateData, global?.language]);

    // 不支持的语言默认返回英语
    const currentLanguage = (translateData, language) =>{
        let currentLan = translateData?.find(item=>item.value === language);
        return currentLan?.value || "en";
    };

    const getName = (name) => {
        if (name && name.length > 2) {
            return name.replace(name.substr(1, name.length - 2), '***')
        }
        return name;
    }

    const translateContent = async (commentId, translateLanguage) => {
        let params = { id: commentId };
        if (translateLanguage) {
            params["targetLanguage"] = translateLanguage;
        }

        let data = await fetchTranslateReview(params);
        setContent(data?.result?.content);
        setDefaultLanguage(data?.result?.language);
    }

    const getTranslateLabel = () => {
        let translateItem = translateData?.find((item) => item.value === defaultLanguage);
        return translateItem.label;
    }

    const changeLanguage = language => {
        translateContent(comment.id, language);
        setShowModal(false);
    }

    const restInitValue = () => {
        setContent(null);
        setDefaultLanguage(currentLanguage(translateData, global?.language));
    }

    const getFittype = type => {
        let label;
        switch (type) {
            case '1':
                label = intl.formatMessage({ id: 'to_large' });
                break;
            case '2':
                label = intl.formatMessage({ id: 'ture_to_size' });
                break;
            case '3':
                label = intl.formatMessage({ id: 'too_small' });
                break;
        }

        return label;
    }

    return (
        <div className={`${classes.ProductReviewItem} ${index === 0 && classes.GolbalBorderTop}`}>
            <div className={classes.ReviewItemFirst}>
                <div className={classes.ReviewCount}>
                    <span className={classes.ReviewCustomerName}>{getName(comment?.customerName)}</span>
                    <ProductStarScore starScore={comment?.score} />
                </div>
                <div className={classes.CreateTime}>{comment?.createTime}</div>
            </div>

            {
                (comment?.color || comment?.size) && <p className={classes.ReviewSizeColorContainer}>
                    {
                        comment?.color && <React.Fragment>
                            <span><FormattedMessage id="color" defaultMessage="Color" />:{comment.color}</span>
                            <span> / </span>
                        </React.Fragment>
                    }
                    {
                        comment?.size && <span><FormattedMessage id="size" defaultMessage="Size" />:{comment.size}</span>
                    }
                </p>
            }


            <p className={classes.ReviewItemContent}>{comment?.content}</p>

            {
                content ? (
                    <div className={classes.TranslateContainer}>
                        <span className={`iconfont ${classes.Close}`} onClick={restInitValue}>&#xe7c9;</span>
                        <div style={{ width: "97%" }} dangerouslySetInnerHTML={{__html:content}}></div>
                        <div className={classes.TranslateSelect} onClick={() => setShowModal(true)}>
                            <span>{getTranslateLabel()}</span>
                            <span className="iconfont" style={{ fontSize: "12px" }}>&#xe692;</span>
                        </div>
                    </div>
                ) : (
                    <div className={classes.ReviewItemTranslate} onClick={() => translateContent(comment.id, defaultLanguage)}><FormattedMessage id="translate" defaultMessage="Translate" /></div>
                )
            }

            <ProductSelectTranslateModal translateData={translateData} selectedLanguage={defaultLanguage} showModal={showModal} onClose={() => setShowModal(false)} changeLanguage={changeLanguage} />

            {
                comment?.images?.length > 0 && <div className={classes.ReviewImageContainer}>
                    {
                        comment.images.map((item, index) => <div className={classes.Item} key={index}>
                            <div className={classes.Image} onClick={() => setImages(comment.images)}>
                                <img src={`${IMAGE_GEEKO_LTD}/comment/medium/${item}`} alt="Image" />
                            </div>
                        </div>
                        )
                    }

                </div>
            }


            {
                comment?.sizingRecommendation && <div className={classes.OverallFitContainer}>
                    <span><FormattedMessage id="overall_fit" defaultMessage="Overall Fit" />:</span>
                    <span>{getFittype(comment.sizingRecommendation)}</span>
                </div>
            }

            {
                images && <ReviewImageMagnify images={images} onClose={() => setImages(null)} />
            }

        </div>
    )
}

const ProductReviewList = withList(props => {
    const { comments, translateData, innerRef } = props;

    return (
        <div ref={innerRef} className={`${classes.ProductMoreReviewBd}`}>
            {props?.children}

            {
                comments?.map((item, index) => <ProductReviewItem key={index} index={index} comment={item} translateData={translateData} />)
            }
        </div>
    )
})

const ProductReview = (props) => {
    useStyles(classes);
    const { innerRef, reviewItem, productId, isBabiesLook, reviewModalShow, hideTitle } = props;
    let commentsItem = reviewItem?.comments;
    const pageProduct = useSelector((state) => state.pageProduct);
    const [translateData, setTranslateData] = useState(pageProduct.translateData);
    const dispatch = useDispatch();

    useEffect(async () => {
        let data = await dispatch(action_fetch_product_detail_translateData("M1542"));
        setTranslateData(data);
    }, []);

    const moreReviewModalShow = () => {
        props?.onShow();
    }

    const moreReviewModalHide = () => {
        props?.onClose();
    }

    return (
        <div className={`${classes.ProductReviewContainer} ${hideTitle ? '': classes.GolbalBorderTop}`}>
            <div ref={innerRef} id="productReviewNav" />
            {
                reviewItem?.total > 0 && <React.Fragment>
                    <div className={classes.Hd}>
                        {
                            !hideTitle && <span className={classes.ReviewFont}><FormattedMessage id="reviews" defaultMessage="Reviews" /> ({reviewItem?.total})</span>
                        }
                        <span className={classes.ReviewCount}>
                            <span className={classes.AvgScorceFont}>{reviewItem?.avgScore?.toFixed(1)}</span>
                            <ProductStarScore starScore={reviewItem?.avgScore} />
                            {
                                isBabiesLook && <Iconfont className={classes.BabiesLookIcon} onClick={moreReviewModalShow}>&#xe694;</Iconfont>
                            }
                        </span>
                    </div>

                    {
                        // !isBabiesLook && 
                        <>
                            {
                                reviewItem?.sizingRecommendation && <ProductReviewEvaluate isDetail={true} sizingRecommendation={reviewItem?.sizingRecommendation} />
                            }

                            <div className={classes.Bd}>
                                {
                                    commentsItem?.length > 0 && commentsItem.slice(0, 2).map((comment, index) => <ProductReviewItem key={index} comment={comment} translateData={translateData} />)
                                }
                            </div>

                            <div className={classes.ReviewitemViewMore} onClick={moreReviewModalShow}>
                                <span><FormattedMessage id="view_more" defaultMessage="View More" /> {'>'}</span>
                            </div>
                        </>
                    }

                    <ProductMoreReviewModal
                        productId={productId}
                        translateData={translateData}
                        moreReviewShow={reviewModalShow}
                        onClose={moreReviewModalHide}
                        total={reviewItem?.total}
                        sizingRecommendation={reviewItem?.sizingRecommendation}
                        avgScore={reviewItem?.avgScore}
                    />
                </React.Fragment>
            }



        </div>
    )
}

export default withObserver(ProductReview);